// API configuratie
// In productie: relatieve URL (nginx proxy)
// In development: localhost:3001

const isProduction = process.env.NODE_ENV === 'production';

export const API_URL = isProduction 
  ? '' // Relatieve URL in productie (nginx proxy)
  : 'http://localhost:3001';

export const SOCKET_URL = isProduction
  ? 'https://wieisdemol.tveurhof.nl'
  : 'http://localhost:3001';
